import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ProductDetailsDialogComponent} from "../../modal/product-details-dialog/product-details-dialog.component";
import {ProductCardUtilService} from "./product-card-util.service";
import {NavigationExtras, Router} from "@angular/router";
import {ProductResponse} from "../../../models/productResponse";
import {CurrencyService} from "../../../service/currency.service";
import {SharedConstants} from "../../../utilityClass/sharedConstants";
import {ImageService} from "../../../service/image.service";
import {UserService} from "../../../service/user.service";
import {ShoppingCartService} from "../../../service/shoppingCart.service";
import {ShoppingCartRequest} from "../../../models/shoppingCartRequest";
import {AttributeValueResponse} from "../../../models/attributeValueResponse";
import {SharedService} from "../../../service/shered.service";
import {CurrencyResponse} from "../../../interface/currencyResponse";

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss', './product-card-media.component.scss']
})
export class ProductCardComponent implements OnInit {
  @Input('productCard') productCard!: ProductResponse;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  quantity: number = 1;
  selectedColor!: number;
  shoppingCartRequest!: ShoppingCartRequest;
  showAddedCheck: boolean = false;
  private addedCheckTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private dialog: MatDialog,
    private productCardUtil: ProductCardUtilService,
    private router: Router,
    private currencyService: CurrencyService,
    private imageService: ImageService,
    private userService: UserService,
    private shoppingCartService: ShoppingCartService,
    private sharedService: SharedService
  ) {
  }

  ngOnInit() {
    this.currencyService.getCurrency(SharedConstants.USD).subscribe({
      next: (data: CurrencyResponse) => {
        const currencyRate = Number(data?.[SharedConstants.USD]);
        this.setConvertedPrice(currencyRate);
      },
      error: () => {
        this.setConvertedPrice(SharedConstants.DOLLAR_EXCHANGE_RATE);
      }
    })
    this.selectedColor = this.productCard.attributeValues[0]?.id
  }

  private setConvertedPrice(currencyRate: number) {
    const safeRate = Number.isFinite(currencyRate) && currencyRate > 0
      ? currencyRate
      : SharedConstants.DOLLAR_EXCHANGE_RATE;
    this.productCard.convertedPrice = this.productCard.price / safeRate;
  }

  get totalPriceUSD(): number {
    return this.productCard.convertedPrice * this.quantity;
  }

  get totalPriceAMD(): number {
    return this.productCard.price * this.quantity;
  }

  selectColor(attributeValue: AttributeValueResponse) {
    this.selectedColor = attributeValue.id;
  }

  protected redirectToProductDetailsPage() {
    this.productCardUtil.unsubscribeAll();

    const navigationExtras: NavigationExtras = {
      state: {
        product: Object.assign({}, this.productCard),
        selectedQuantity: this.quantity,
        selectedColor: this.selectedColor
      }
    }
    this.router.navigate(['product/details'], navigationExtras).then().catch();
  }

  openProductDetailsDialog() {
    const dialogConfig: MatDialogConfig = {
      height: '600px',
      data: {
        product: this.productCard,
        selectedQuantity: this.quantity,
        selectedColor: this.selectedColor,
        totalPriceUSD: this.totalPriceUSD,
        totalPriceAMD: this.totalPriceAMD,
      }
    };

    this.dialog.open(ProductDetailsDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe({
        next: () => {
        },
        error: () => {
          throw new Error('Error occurred while closing the dialog');
        }
      });
  }

  protected isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  increaseQuantity() {
    this.quantity++;
  }

  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  getProductImageUrl(imageName: string) {
    return this.imageService.getImageUrl(imageName)
  }

  addToCart() {
    this.shoppingCartRequest = {
      productId: this.productCard.id,
      quantity: this.quantity,
      attributeValueIds: [this.selectedColor],
      isFromOutOfCart: true
    };

    if (this.userService.isLoggedIn()) {
      this.shoppingCartService.addProductToBucket(this.shoppingCartRequest).subscribe({
        next: () => {
          this.sharedService.needToUpdate()
          this.productCard.isAddedToCart = true;
          this.showAddedCheck = true;
          if (this.addedCheckTimeoutId) {
            clearTimeout(this.addedCheckTimeoutId);
          }
          this.addedCheckTimeoutId = setTimeout(() => {
            this.showAddedCheck = false;
          }, 2000);
        },
        error: (err) => console.error('Failed to add to cart', err),
      });
    } else {
      this.userService.setRedirectUrl(this.router.url);
      this.router.navigate(['/login']);
    }
  }

  goToCart() {
    this.router.navigate(['/cart']);
  }

  protected readonly SharedConstants = SharedConstants;

}
